var sections = document.getElementsByClassName('collection collections-grid-tabs')

Array.from(sections).forEach(section => {
    var options = section.getElementsByClassName('collections-grid-tabs-tabs-item')
    Array.from(options).forEach(option => {
        // Agrega un listener al evento 'click' en cada opción
        option.addEventListener('click', function() {
            // Remueve la clase 'active' de todas las opciones
            Array.from(options).forEach(opt => opt.classList.remove('active'));

            // Agrega la clase 'active' a la opción actual
            option.classList.add('active');

            // Obtiene el ID asociado a la opción
            var idOption = option.id;
            // Selecciona el elemento con el ID correspondiente y le agrega la clase 'active'
            var productCollection = document.getElementById(`collections-grid-tabs-content-${idOption}`);
            if (productCollection) {
                // Remueve la clase 'active' de todos los elementos con id similar
                Array.from(document.querySelectorAll('[id^="collections-grid-tabs-content-"]')).forEach(prod => prod.classList.remove('active'));
                
                // Agrega la clase 'active' al elemento correspondiente
                productCollection.classList.add('active');
            }
        });
    });
});